module.exports = __webpack_public_path__ + "img/logo.0cd293a3.png";